import script from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatus.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=48a0fe7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a0fe7c"]])

export default __exports__